// libs
import styled from 'styled-components'
// static
import CloseIconOrigin from '@mui/icons-material/Cancel'
// themes
import colors from 'themes/colors'
// utils
import { darken, size } from 'polished'

export const CloseIcon = styled(CloseIconOrigin)<any>`
  && {
    cursor: pointer;
    margin-right: 12px;
  }

  path {
    fill: ${colors.gray450};
  }

  &:hover {
    path {
      fill: ${darken(0.1, colors.gray450)};
    }
  }

  ${size('18px')};
`

export const LinkWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: unset;
`

export const Link = styled('a')`
  color: ${colors.black};
`
